var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 19.2178 5.5723",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{isolation:isolate;}.cls-3{clip-path:url(#clip-path);}.cls-4{fill:#000003;}.cls-5{clip-path:url(#clip-path-2);}.cls-6{mix-blend-mode:screen;}.cls-7{fill:#00009e;}.cls-8{fill:#0000a3;}.cls-9{fill:#0000a2;}.cls-10{fill:#0000a9;}.cls-11{fill:#0000a8;}.cls-12{fill:#00a;}.cls-13{fill:#0000a6;}.cls-14{fill:#0000b2;}.cls-15{fill:#0000b0;}.cls-16{fill:#0000af;}.cls-17{fill:#0000ab;}.cls-18{fill:#0000b8;}.cls-19{fill:#0000b7;}.cls-20{fill:#0000b6;}.cls-21{fill:#0000b3;}.cls-22{fill:#0000ac;}.cls-23{fill:#0000a5;}.cls-24{fill:#0000a0;}.cls-25{fill:#0000ba;}.cls-26{fill:#00b;}.cls-27{fill:#0000b9;}.cls-28{fill:#0000b5;}.cls-29{fill:#00009f;}.cls-30{fill:#0000be;}.cls-31{fill:#0000bd;}.cls-32{fill:#0000bf;}.cls-33{fill:#0000c1;}.cls-34{fill:#0000bc;}.cls-35{fill:#0000c2;}.cls-36{fill:#0000c3;}.cls-37{fill:#0000ad;}.cls-38{fill:#0000c4;}.cls-39{fill:#0000c0;}.cls-40{fill:#006503;}.cls-41{fill:#006b03;}.cls-42{fill:#006a03;}.cls-43{fill:#006f03;}.cls-44{fill:#006e03;}.cls-45{fill:#006d03;}.cls-46{fill:#007203;}.cls-47{fill:#007703;}.cls-48{fill:#007303;}.cls-49{fill:#007403;}.cls-50{fill:#007a03;}.cls-51{fill:#007603;}.cls-52{fill:#007803;}.cls-53{fill:#007c03;}.cls-54{fill:#008503;}.cls-55{fill:#008d03;}.cls-56{fill:#007903;}.cls-57{fill:#007e03;}.cls-58{fill:#007d03;}.cls-59{fill:#008203;}.cls-60{fill:#008c03;}.cls-61{fill:#008b03;}.cls-62{fill:#009003;}.cls-63{fill:#008003;}.cls-64{fill:#009203;}.cls-65{fill:#008103;}.cls-66{fill:#008a03;}.cls-67{fill:#008803;}.cls-68{fill:#008403;}.cls-69{fill:#008603;}.cls-70{fill:#008303;}.cls-71{fill:#008903;}.cls-72{fill:#009303;}.cls-73{fill:#008e03;}.cls-74{fill:#009103;}.cls-75{fill:#007b03;}.cls-76{fill:#007103;}.cls-77{fill:#006c03;}.cls-78{fill:#0e0003;}.cls-79{fill:#140003;}.cls-80{fill:#170003;}.cls-81{fill:#160003;}.cls-82{fill:#180003;}.cls-83{fill:#1c0003;}.cls-84{fill:#190003;}.cls-85{fill:#1b0003;}.cls-86{fill:#1f0003;}.cls-87{fill:#200003;}.cls-88{fill:#1e0003;}.cls-89{fill:#220003;}.cls-90{fill:#2c0003;}.cls-91{fill:#340003;}.cls-92{fill:#230003;}.cls-93{fill:#290003;}.cls-94{fill:#310003;}.cls-95{fill:#300003;}.cls-96{fill:#360003;}.cls-97{fill:#240003;}.cls-98{fill:#370003;}.cls-99{fill:#260003;}.cls-100{fill:#2d0003;}.cls-101{fill:#270003;}.cls-102{fill:#2a0003;}.cls-103{fill:#330003;}.cls-104{fill:#2e0003;}.cls-105{fill:#120003;}.cls-106{fill:#0f0003;}.cls-107{fill:#100003;}.cls-108{mix-blend-mode:soft-light;}.cls-109{fill:#000058;}.cls-110{fill:#000071;}.cls-111{fill:#008;}.cls-112{fill:#0000cb;}.cls-113{fill:#00007f;}.cls-114{fill:#0000e2;}.cls-115{fill:#0000a7;}.cls-116{fill:#0000b4;}.cls-117{fill:#000087;}.cls-118{fill:#000070;}.cls-119{fill:#000040;}.cls-120{fill:#000027;}.cls-121{fill:#000054;}.cls-122{fill:#00000f;}.cls-123{fill:#000025;}.cls-124{fill:#000039;}.cls-125{fill:#00004d;}.cls-126{fill:#000043;}.cls-127{fill:#00006b;}.cls-128{fill:#000057;}.cls-129{fill:#000075;}.cls-130{fill:#000060;}.cls-131{fill:#00007e;}.cls-132{fill:#00009b;}.cls-133{fill:#000091;}.cls-134{fill:#0000a4;}.cls-135{fill:#0000c8;}.cls-136{fill:blue;}.cls-137{fill:#0000d2;}.cls-138{fill:#0000db;}.cls-139{fill:#002c03;}.cls-140{fill:#004503;}.cls-141{fill:#005c03;}.cls-142{fill:#009f03;}.cls-143{fill:#005303;}.cls-144{fill:#00b603;}.cls-145{fill:#005b03;}.cls-146{fill:#004403;}.cls-147{fill:#001403;}.cls-148{fill:#002803;}.cls-149{fill:#000d03;}.cls-150{fill:#002103;}.cls-151{fill:#001703;}.cls-152{fill:#003f03;}.cls-153{fill:#002b03;}.cls-154{fill:#004903;}.cls-155{fill:#003403;}.cls-156{fill:#005203;}.cls-157{fill:#009c03;}.cls-158{fill:#009403;}.cls-159{fill:#00d603;}.cls-160{fill:#00a603;}.cls-161{fill:#00af03;}.cls-162{fill:#0b0003;}.cls-163{fill:#390003;}.cls-164{fill:#4f0003;}.cls-165{fill:#650003;}.cls-166{fill:#7c0003;}.cls-167{fill:#410003;}.cls-168{fill:#4e0003;}.cls-169{fill:#210003;}.cls-170{fill:#0a0003;}.cls-171{fill:#380003;}.cls-172{fill:#050003;}.cls-173{fill:#350003;}.cls-174{fill:#2b0003;}.cls-175{fill:#500003;}.cls-176{fill:#470003;}.cls-177{fill:#3e0003;}.cls-178{fill:#620003;}.cls-179{fill:#5a0003;}.cls-180{fill:#9c0003;}.cls-181{fill:#6c0003;}.cls-182{fill:#750003;}.cls-183{fill:#fff;opacity:0.2;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 19.2178,
    height: 5.5723
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -0.5556,
    y: -7.332,
    width: 20.3281,
    height: 20.3281
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: -0.5556,
    y: -2.1679,
    width: 20.3281,
    height: 9.3965
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: -0.8835,
    y: -0.5641,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.0419 -0.351) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 0.2995,
    y: -0.5638,
    width: 0.8776,
    height: 0.8776,
    transform: "translate(0.3056 0.4861) rotate(-45.0918)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: -0.2927,
    y: 0.0268,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.2867 0.2401) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: -0.8834,
    y: 0.6194,
    width: 0.8779,
    height: 0.8779,
    transform: "translate(-0.8782 -0.0044) rotate(-44.9815)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 1.4812,
    y: -0.5641,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(0.6514 1.3217) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 0.8904,
    y: 0.0267,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.06 1.0766) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 0.2996,
    y: 0.6197,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(-0.5323 0.8332) rotate(-45.0503)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: -0.2925,
    y: 1.2098,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-1.1234 0.5869) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: -0.8833,
    y: 1.8006,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-1.7145 0.3422) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 2.6643,
    y: -0.5641,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(0.9982 2.1587) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 2.0735,
    y: 0.0267,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.4065 1.9132) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 1.4813,
    y: 0.6194,
    width: 0.8779,
    height: 0.8779,
    transform: "translate(-0.1861 1.6672) rotate(-44.9815)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 0.8906,
    y: 1.2097,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.7764 1.4231) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 0.2996,
    y: 1.8009,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(-1.3691 1.1814) rotate(-45.0918)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: -0.2927,
    y: 2.393,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.9605 0.9339) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: -0.8835,
    y: 2.9838,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-2.5516 0.6891) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 3.8474,
    y: -0.5641,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(1.3439 2.9945) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 3.2558,
    y: 0.0271,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(0.7536 2.7501) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 2.6644,
    y: 0.6194,
    width: 0.8779,
    height: 0.8779,
    transform: "translate(0.1601 2.5035) rotate(-44.9815)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 2.0737,
    y: 1.2097,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.4299 2.2597) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 1.4814,
    y: 1.8006,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-1.0213 2.015) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 0.8904,
    y: 2.3929,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.6132 1.7697) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 0.2995,
    y: 2.9841,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-2.2071 1.5293) rotate(-45.0918)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: -0.2924,
    y: 3.5765,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(-2.793 1.276) rotate(-44.9307)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: -0.8833,
    y: 4.1668,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-3.3884 1.0359) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 5.0306,
    y: -0.5641,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(1.6904 3.8311) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 4.4383,
    y: 0.0267,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.0991 3.5854) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 3.8476,
    y: 0.6194,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.5055 3.3383) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 3.256,
    y: 1.2101,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(-0.0831 3.0969) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 2.6645,
    y: 1.8006,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-0.6744 2.8519) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 2.0735,
    y: 2.3929,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.2666 2.6063) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 1.4812,
    y: 2.9838,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.8583 2.3619) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0.8908,
    y: 3.5764,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-2.4467 2.1101) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 0.2996,
    y: 4.1671,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(-3.0449 1.8771) rotate(-45.0918)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: -0.2925,
    y: 4.7581,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-3.6306 1.6242) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: -0.8835,
    y: 5.35,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-4.2255 1.3829) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 6.2122,
    y: -0.5641,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(2.0365 4.6666) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 5.6214,
    y: 0.0267,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.4457 4.422) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 5.0307,
    y: 0.6194,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.8514 4.1743) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 4.4385,
    y: 1.2097,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.2627 3.9318) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 3.8476,
    y: 1.8005,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.3281 3.687) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 3.2558,
    y: 2.3933,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.9202 3.4439) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 2.6643,
    y: 2.9838,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.5115 3.1988) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 2.0739,
    y: 3.5764,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-2.1015 2.9453) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 1.4814,
    y: 4.1668,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-2.6951 2.7087) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 0.8906,
    y: 4.758,
    width: 0.878,
    height: 0.878,
    transform: "translate(-3.2832 2.4586) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 0.2995,
    y: 5.3503,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-3.883 2.225) rotate(-45.0918)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 7.3953,
    y: -0.5641,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(2.383 5.5032) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 6.8045,
    y: 0.0267,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.7922 5.2585) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 6.2124,
    y: 0.6194,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.1969 5.0093) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 5.6216,
    y: 1.2097,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.6093 4.7684) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 5.0307,
    y: 1.8006,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.0184 4.5236) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 4.4383,
    y: 2.3929,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.574 4.2784) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 3.8474,
    y: 2.9837,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.1648 4.0336) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 3.2561,
    y: 3.5767,
    width: 0.877,
    height: 0.877,
    transform: "translate(-1.7568 3.7819) rotate(-44.9307)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 2.6645,
    y: 4.1668,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-2.3482 3.5456) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 2.0737,
    y: 4.758,
    width: 0.878,
    height: 0.878,
    transform: "translate(-2.9374 3.2945) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 1.4812,
    y: 5.35,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-3.5322 3.0556) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 8.5781,
    y: -0.5641,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(2.7295 6.3395) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "9.046 0.466 8.426 1.087 7.806 0.466 8.426 -0.155 9.046 0.466"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 7.3955,
    y: 0.6194,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.5428 5.8453) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 6.8047,
    y: 1.2097,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.9558 5.605) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 6.2124,
    y: 1.8005,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.3645 5.3592) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 5.6214,
    y: 2.3929,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.2275 5.115) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 5.0306,
    y: 2.9837,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(-0.8183 4.8702) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 4.4387,
    y: 3.5764,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-1.4116 4.6148) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 3.8476,
    y: 4.1667,
    width: 0.878,
    height: 0.878,
    transform: "translate(-2.0012 4.3801) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 3.256,
    y: 4.7584,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(-2.5923 4.1321) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 2.6643,
    y: 5.35,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-3.1853 3.8925) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 9.7615,
    y: -0.5641,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(3.079 7.1792) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 9.1697,
    y: 0.0267,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.485 6.9311) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 8.5783,
    y: 0.6194,
    width: 0.8779,
    height: 0.8779,
    transform: "translate(1.8886 6.681) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 7.9876,
    y: 1.2101,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(1.306 6.4469) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 7.3955,
    y: 1.8005,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.7111 6.1958) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 6.8045,
    y: 2.3929,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.119 5.9516) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 6.2122,
    y: 2.9837,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.4722 5.7058) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 5.6218,
    y: 3.5764,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-1.0664 5.45) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 5.0307,
    y: 4.1668,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.6547 5.2167) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 4.4385,
    y: 4.758,
    width: 0.878,
    height: 0.878,
    transform: "translate(-2.2461 4.9654) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 3.8474,
    y: 5.3499,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-2.838 4.7267) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 10.9441,
    y: -0.564,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.4223 8.0123) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 10.3527,
    y: 0.0269,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.8373 7.7738) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 9.7616,
    y: 0.6194,
    width: 0.8779,
    height: 0.8779,
    transform: "translate(2.2372 7.5203) rotate(-44.9815)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 9.1699,
    y: 1.2097,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.6486 7.2775) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 8.5783,
    y: 1.8006,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(1.0575 7.0321) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "9.046 2.832 8.426 3.453 7.806 2.832 8.426 2.211 9.046 2.832"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 7.3953,
    y: 2.9837,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.1257 6.5424) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 6.8049,
    y: 3.5764,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.7212 6.2853) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 6.2124,
    y: 4.1667,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.3086 6.0522) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 5.6216,
    y: 4.758,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.9003 5.8013) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 5.0306,
    y: 5.3499,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(-2.4915 5.5633) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 12.1263,
    y: -0.5641,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(3.7687 8.8485) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 11.5349,
    y: 0.0269,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.1783 8.604) rotate(-45.0046)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 10.9442,
    y: 0.6195,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.5803 8.3526) rotate(-44.9579)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 10.3529,
    y: 1.2099,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.0002 8.1209) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 9.7617,
    y: 1.8006,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(1.4063 7.8724) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 9.1697,
    y: 2.3929,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.8118 7.6241) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 8.5781,
    y: 2.9838,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(0.2207 7.3787) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 7.9878,
    y: 3.5767,
    width: 0.877,
    height: 0.877,
    transform: "translate(-0.3737 7.1272) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 7.3955,
    y: 4.1667,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.9621 6.8888) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 6.8047,
    y: 4.758,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.5544 6.6372) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 6.2122,
    y: 5.3499,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-2.1454 6.3988) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 13.3098,
    y: -0.564,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.1224 9.6922) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 12.7181,
    y: 0.0267,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(3.5242 9.44) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 12.1264,
    y: 0.6194,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.926 9.1881) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 11.5351,
    y: 1.2099,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.3418 8.9505) rotate(-45.0046)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 10.9442,
    y: 1.8007,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(1.7504 8.7049) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 10.3527,
    y: 2.3931,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.1628 8.4682) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 9.7615,
    y: 2.9838,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(0.5693 8.2193) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 9.1701,
    y: 3.5764,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.0311 7.9551) rotate(-44.9082)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 8.5783,
    y: 4.1668,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-0.6157 7.7251) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 7.9876,
    y: 4.7584,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(-1.2069 7.4805) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 7.3953,
    y: 5.3499,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.7988 7.2354) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 14.4925,
    y: -0.564,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.4703 10.53) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 13.9007,
    y: 0.0267,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(3.8707 10.2764) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 13.3099,
    y: 0.6195,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(3.2785 10.0318) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 12.7182,
    y: 1.2098,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.6878 9.7865) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 12.1264,
    y: 1.8006,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.0967 9.541) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 11.5349,
    y: 2.3931,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.505 9.2972) rotate(-45.0046)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 10.944,
    y: 2.9839,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.9136 9.0515) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 10.3531,
    y: 3.5765,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(0.3178 8.7985) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 9.7617,
    y: 4.1668,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-0.2675 8.5661) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 9.1699,
    y: 4.758,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.863 8.3084) rotate(-44.9544)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 8.5781,
    y: 5.35,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.4524 8.0717) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 15.6751,
    y: -0.5641,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(4.8081 11.3579) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 15.0833,
    y: 0.0267,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(4.217 11.1125) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 14.4926,
    y: 0.6195,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(3.6257 10.869) rotate(-45.0046)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 13.9009,
    y: 1.2097,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.0343 10.6229) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 13.3099,
    y: 1.8007,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.4492 10.386) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 12.7181,
    y: 2.3929,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(1.8511 10.1331) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 12.1263,
    y: 2.9837,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(1.26 9.8876) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 11.5352,
    y: 3.5765,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(0.6593 9.6255) rotate(-44.9122)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 10.9442,
    y: 4.1669,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(0.0772 9.3979) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 10.3529,
    y: 4.7582,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.514 9.1531) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 9.7615,
    y: 5.35,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.1046 8.913) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 16.8582,
    y: -0.564,
    width: 0.878,
    height: 0.878,
    transform: "translate(5.1547 12.1945) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 16.2669,
    y: 0.0267,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(4.5637 11.9495) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 15.6753,
    y: 0.6194,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.9637 11.6957) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 15.0835,
    y: 1.2097,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.3806 11.459) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 14.4926,
    y: 1.8007,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.797 11.2239) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 13.9007,
    y: 2.3929,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.1975 10.9695) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 13.3098,
    y: 2.9839,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.6119 10.7332) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 12.7184,
    y: 3.5764,
    width: 0.8776,
    height: 0.8776,
    transform: "translate(1.0041 10.46) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 12.1264,
    y: 4.1668,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.4236 10.2341) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 11.5351,
    y: 4.7582,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.1713 9.9802) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 10.944,
    y: 5.3501,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.7595 9.7445) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 18.0408,
    y: -0.564,
    width: 0.878,
    height: 0.878,
    transform: "translate(5.501 13.0306) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 17.4495,
    y: 0.0267,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(4.91 12.7857) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 16.8583,
    y: 0.6195,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(4.3096 12.5317) rotate(-44.9591)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 16.2671,
    y: 1.2097,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.7273 12.2959) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 15.6753,
    y: 1.8005,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.1362 12.0505) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 15.0833,
    y: 2.3929,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.5438 11.8056) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 14.4924,
    y: 2.9839,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.9595 11.5711) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 13.9011,
    y: 3.5764,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(1.3492 11.2951) rotate(-44.9082)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 13.3099,
    y: 4.1669,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(0.7749 11.0803) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 12.7182,
    y: 4.7581,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.1743 10.8153) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 12.1263,
    y: 5.3499,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(-0.4132 10.5807) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 19.2239,
    y: -0.5641,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(5.8476 13.8673) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 18.6321,
    y: 0.0267,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(5.2564 13.6219) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 18.0409,
    y: 0.6195,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(4.6553 13.3671) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 17.4497,
    y: 1.2097,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.0736 13.1321) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 16.8583,
    y: 1.8007,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(3.4827 12.887) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 16.2669,
    y: 2.3929,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.8905 12.6425) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 15.6751,
    y: 2.9837,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.2994 12.3971) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 15.0837,
    y: 3.5764,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(1.6942 12.1298) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 14.4926,
    y: 4.1669,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(1.1225 11.9183) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 13.9009,
    y: 4.758,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.5201 11.651) rotate(-44.9544)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 13.3098,
    y: 5.3501,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.0625 11.4275) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 19.2241,
    y: 0.6194,
    width: 0.878,
    height: 0.878,
    transform: "translate(5.0013 14.2033) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 18.6323,
    y: 1.2097,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.42 13.9684) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 18.0409,
    y: 1.8007,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(3.829 13.7231) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 17.4495,
    y: 2.3929,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(3.2369 13.4787) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 16.8581,
    y: 2.9839,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.646 13.2336) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 16.2673,
    y: 3.5764,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.0395 12.9654) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 15.6753,
    y: 4.1667,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.463 12.7435) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 15.0835,
    y: 4.758,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.8657 12.4864) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 14.4924,
    y: 5.3501,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.285 12.2655) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 19.2241,
    y: 1.8005,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.1756 14.5599) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 18.6321,
    y: 2.3929,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(3.5833 14.3149) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 18.0407,
    y: 2.9839,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.9922 14.0697) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 17.4499,
    y: 3.5764,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.3845 13.8003) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 16.8583,
    y: 4.1669,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(1.8096 13.5801) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 16.2671,
    y: 4.758,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.2117 13.3227) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 15.6751,
    y: 5.3499,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.6263 13.0901) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 19.2239,
    y: 2.9837,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(3.3388 14.9065) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 18.6325,
    y: 3.5764,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.7295 14.6351) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 18.0409,
    y: 4.1669,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.1558 14.4161) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 17.4497,
    y: 4.758,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.5574 14.1582) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 16.8581,
    y: 5.3501,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.9728 13.9267) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 19.2241,
    y: 4.1667,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.5024 15.2529) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 18.6323,
    y: 4.758,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.9031 14.9938) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 18.0407,
    y: 5.3501,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.3191 14.7627) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 19.2239,
    y: 5.3499,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.6657 15.5995) rotate(-45)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: -0.8835,
    y: -0.5641,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.0419 -0.351) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 0.2995,
    y: -0.5638,
    width: 0.8776,
    height: 0.8776,
    transform: "translate(0.3056 0.4861) rotate(-45.0918)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: -0.2927,
    y: 0.0268,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.2867 0.2401) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: -0.8834,
    y: 0.6194,
    width: 0.8779,
    height: 0.8779,
    transform: "translate(-0.8782 -0.0044) rotate(-44.9815)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 1.4812,
    y: -0.5641,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(0.6514 1.3217) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 0.8904,
    y: 0.0267,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.06 1.0766) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 0.2996,
    y: 0.6197,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(-0.5323 0.8332) rotate(-45.0503)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: -0.2925,
    y: 1.2098,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-1.1234 0.5869) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: -0.8833,
    y: 1.8006,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-1.7145 0.3422) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 2.6643,
    y: -0.5641,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(0.9982 2.1587) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 2.0735,
    y: 0.0267,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.4065 1.9132) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 1.4813,
    y: 0.6194,
    width: 0.8779,
    height: 0.8779,
    transform: "translate(-0.1861 1.6672) rotate(-44.9815)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 0.8906,
    y: 1.2097,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.7764 1.4231) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 0.2996,
    y: 1.8009,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(-1.3691 1.1814) rotate(-45.0918)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: -0.2927,
    y: 2.393,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.9605 0.9339) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: -0.8835,
    y: 2.9838,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-2.5516 0.6891) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 3.8474,
    y: -0.5641,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(1.3439 2.9945) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 3.2558,
    y: 0.0271,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(0.7536 2.7501) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 2.6644,
    y: 0.6194,
    width: 0.8779,
    height: 0.8779,
    transform: "translate(0.1601 2.5035) rotate(-44.9815)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 2.0737,
    y: 1.2097,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.4299 2.2597) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 1.4814,
    y: 1.8006,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-1.0213 2.015) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 0.8904,
    y: 2.3929,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.6132 1.7697) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 0.2995,
    y: 2.9841,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-2.2071 1.5293) rotate(-45.0918)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: -0.2924,
    y: 3.5765,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(-2.793 1.276) rotate(-44.9307)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: -0.8833,
    y: 4.1668,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-3.3884 1.0359) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 5.0306,
    y: -0.5641,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(1.6904 3.8311) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 4.4383,
    y: 0.0267,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.0991 3.5854) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 3.8476,
    y: 0.6194,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.5055 3.3383) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 3.256,
    y: 1.2101,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(-0.0831 3.0969) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 2.6645,
    y: 1.8006,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-0.6744 2.8519) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 2.0735,
    y: 2.3929,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.2666 2.6063) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 1.4812,
    y: 2.9838,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.8583 2.3619) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 0.8908,
    y: 3.5764,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-2.4467 2.1101) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 0.2996,
    y: 4.1671,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(-3.0449 1.8771) rotate(-45.0918)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: -0.2925,
    y: 4.7581,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-3.6306 1.6242) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-62",
    x: -0.8835,
    y: 5.35,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-4.2255 1.3829) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 6.2122,
    y: -0.5641,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(2.0365 4.6666) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 5.6214,
    y: 0.0267,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.4457 4.422) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 5.0307,
    y: 0.6194,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.8514 4.1743) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 4.4385,
    y: 1.2097,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.2627 3.9318) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 3.8476,
    y: 1.8005,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.3281 3.687) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 3.2558,
    y: 2.3933,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.9202 3.4439) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 2.6643,
    y: 2.9838,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.5115 3.1988) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 2.0739,
    y: 3.5764,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-2.1015 2.9453) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 1.4814,
    y: 4.1668,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-2.6951 2.7087) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 0.8906,
    y: 4.758,
    width: 0.878,
    height: 0.878,
    transform: "translate(-3.2832 2.4586) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 0.2995,
    y: 5.3503,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-3.883 2.225) rotate(-45.0918)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 7.3953,
    y: -0.5641,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(2.383 5.5032) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 6.8045,
    y: 0.0267,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.7922 5.2585) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 6.2124,
    y: 0.6194,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.1969 5.0093) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 5.6216,
    y: 1.2097,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.6093 4.7684) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 5.0307,
    y: 1.8006,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.0184 4.5236) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 4.4383,
    y: 2.3929,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.574 4.2784) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 3.8474,
    y: 2.9837,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.1648 4.0336) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 3.2561,
    y: 3.5767,
    width: 0.877,
    height: 0.877,
    transform: "translate(-1.7568 3.7819) rotate(-44.9307)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 2.6645,
    y: 4.1668,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-2.3482 3.5456) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 2.0737,
    y: 4.758,
    width: 0.878,
    height: 0.878,
    transform: "translate(-2.9374 3.2945) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 1.4812,
    y: 5.35,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-3.5322 3.0556) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 8.5781,
    y: -0.5641,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(2.7295 6.3395) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-59",
    points: "9.046 0.466 8.426 1.087 7.806 0.466 8.426 -0.155 9.046 0.466"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 7.3955,
    y: 0.6194,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.5428 5.8453) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 6.8047,
    y: 1.2097,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.9558 5.605) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 6.2124,
    y: 1.8005,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.3645 5.3592) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 5.6214,
    y: 2.3929,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.2275 5.115) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 5.0306,
    y: 2.9837,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(-0.8183 4.8702) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 4.4387,
    y: 3.5764,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-1.4116 4.6148) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 3.8476,
    y: 4.1667,
    width: 0.878,
    height: 0.878,
    transform: "translate(-2.0012 4.3801) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 3.256,
    y: 4.7584,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(-2.5923 4.1321) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 2.6643,
    y: 5.35,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-3.1853 3.8925) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 9.7615,
    y: -0.5641,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(3.079 7.1792) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 9.1697,
    y: 0.0267,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.485 6.9311) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 8.5783,
    y: 0.6194,
    width: 0.8779,
    height: 0.8779,
    transform: "translate(1.8886 6.681) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 7.9876,
    y: 1.2101,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(1.306 6.4469) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 7.3955,
    y: 1.8005,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.7111 6.1958) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 6.8045,
    y: 2.3929,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.119 5.9516) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 6.2122,
    y: 2.9837,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.4722 5.7058) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 5.6218,
    y: 3.5764,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-1.0664 5.45) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 5.0307,
    y: 4.1668,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.6547 5.2167) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 4.4385,
    y: 4.758,
    width: 0.878,
    height: 0.878,
    transform: "translate(-2.2461 4.9654) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 3.8474,
    y: 5.3499,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-2.838 4.7267) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 10.9441,
    y: -0.564,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.4223 8.0123) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 10.3527,
    y: 0.0269,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.8373 7.7738) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 9.7616,
    y: 0.6194,
    width: 0.8779,
    height: 0.8779,
    transform: "translate(2.2372 7.5203) rotate(-44.9815)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 9.1699,
    y: 1.2097,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.6486 7.2775) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 8.5783,
    y: 1.8006,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(1.0575 7.0321) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "9.046 2.832 8.426 3.453 7.806 2.832 8.426 2.211 9.046 2.832"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 7.3953,
    y: 2.9837,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.1257 6.5424) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 6.8049,
    y: 3.5764,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.7212 6.2853) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 6.2124,
    y: 4.1667,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.3086 6.0522) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 5.6216,
    y: 4.758,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.9003 5.8013) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 5.0306,
    y: 5.3499,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(-2.4915 5.5633) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 12.1263,
    y: -0.5641,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(3.7687 8.8485) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 11.5349,
    y: 0.0269,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.1783 8.604) rotate(-45.0046)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 10.9442,
    y: 0.6195,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.5803 8.3526) rotate(-44.9579)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 10.3529,
    y: 1.2099,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.0002 8.1209) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 9.7617,
    y: 1.8006,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(1.4063 7.8724) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 9.1697,
    y: 2.3929,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.8118 7.6241) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 8.5781,
    y: 2.9838,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(0.2207 7.3787) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 7.9878,
    y: 3.5767,
    width: 0.877,
    height: 0.877,
    transform: "translate(-0.3737 7.1272) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 7.3955,
    y: 4.1667,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.9621 6.8888) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 6.8047,
    y: 4.758,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.5544 6.6372) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 6.2122,
    y: 5.3499,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-2.1454 6.3988) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 13.3098,
    y: -0.564,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.1224 9.6922) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 12.7181,
    y: 0.0267,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(3.5242 9.44) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 12.1264,
    y: 0.6194,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.926 9.1881) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 11.5351,
    y: 1.2099,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.3418 8.9505) rotate(-45.0046)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 10.9442,
    y: 1.8007,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(1.7504 8.7049) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 10.3527,
    y: 2.3931,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.1628 8.4682) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 9.7615,
    y: 2.9838,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(0.5693 8.2193) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 9.1701,
    y: 3.5764,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.0311 7.9551) rotate(-44.9082)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 8.5783,
    y: 4.1668,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-0.6157 7.7251) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 7.9876,
    y: 4.7584,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(-1.2069 7.4805) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 7.3953,
    y: 5.3499,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.7988 7.2354) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 14.4925,
    y: -0.564,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.4703 10.53) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 13.9007,
    y: 0.0267,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(3.8707 10.2764) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 13.3099,
    y: 0.6195,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(3.2785 10.0318) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 12.7182,
    y: 1.2098,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.6878 9.7865) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 12.1264,
    y: 1.8006,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.0967 9.541) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 11.5349,
    y: 2.3931,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.505 9.2972) rotate(-45.0046)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 10.944,
    y: 2.9839,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.9136 9.0515) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 10.3531,
    y: 3.5765,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(0.3178 8.7985) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 9.7617,
    y: 4.1668,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-0.2675 8.5661) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 9.1699,
    y: 4.758,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.863 8.3084) rotate(-44.9544)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 8.5781,
    y: 5.35,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.4524 8.0717) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 15.6751,
    y: -0.5641,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(4.8081 11.3579) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 15.0833,
    y: 0.0267,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(4.217 11.1125) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 14.4926,
    y: 0.6195,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(3.6257 10.869) rotate(-45.0046)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 13.9009,
    y: 1.2097,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.0343 10.6229) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 13.3099,
    y: 1.8007,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.4492 10.386) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 12.7181,
    y: 2.3929,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(1.8511 10.1331) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 12.1263,
    y: 2.9837,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(1.26 9.8876) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 11.5352,
    y: 3.5765,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(0.6593 9.6255) rotate(-44.9122)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 10.9442,
    y: 4.1669,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(0.0772 9.3979) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 10.3529,
    y: 4.7582,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.514 9.1531) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 9.7615,
    y: 5.35,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.1046 8.913) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 16.8582,
    y: -0.564,
    width: 0.878,
    height: 0.878,
    transform: "translate(5.1547 12.1945) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 16.2669,
    y: 0.0267,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(4.5637 11.9495) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 15.6753,
    y: 0.6194,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.9637 11.6957) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 15.0835,
    y: 1.2097,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.3806 11.459) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 14.4926,
    y: 1.8007,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.797 11.2239) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 13.9007,
    y: 2.3929,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.1975 10.9695) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 13.3098,
    y: 2.9839,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.6119 10.7332) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 12.7184,
    y: 3.5764,
    width: 0.8776,
    height: 0.8776,
    transform: "translate(1.0041 10.46) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 12.1264,
    y: 4.1668,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.4236 10.2341) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 11.5351,
    y: 4.7582,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.1713 9.9802) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 10.944,
    y: 5.3501,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.7595 9.7445) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-74",
    x: 18.0408,
    y: -0.564,
    width: 0.878,
    height: 0.878,
    transform: "translate(5.501 13.0306) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 17.4495,
    y: 0.0267,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(4.91 12.7857) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 16.8583,
    y: 0.6195,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(4.3096 12.5317) rotate(-44.9591)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 16.2671,
    y: 1.2097,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.7273 12.2959) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 15.6753,
    y: 1.8005,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.1362 12.0505) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 15.0833,
    y: 2.3929,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.5438 11.8056) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 14.4924,
    y: 2.9839,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.9595 11.5711) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 13.9011,
    y: 3.5764,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(1.3492 11.2951) rotate(-44.9082)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 13.3099,
    y: 4.1669,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(0.7749 11.0803) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 12.7182,
    y: 4.7581,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.1743 10.8153) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 12.1263,
    y: 5.3499,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(-0.4132 10.5807) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 19.2239,
    y: -0.5641,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(5.8476 13.8673) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 18.6321,
    y: 0.0267,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(5.2564 13.6219) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 18.0409,
    y: 0.6195,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(4.6553 13.3671) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 17.4497,
    y: 1.2097,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.0736 13.1321) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 16.8583,
    y: 1.8007,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(3.4827 12.887) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 16.2669,
    y: 2.3929,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.8905 12.6425) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 15.6751,
    y: 2.9837,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.2994 12.3971) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 15.0837,
    y: 3.5764,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(1.6942 12.1298) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 14.4926,
    y: 4.1669,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(1.1225 11.9183) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 13.9009,
    y: 4.758,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.5201 11.651) rotate(-44.9544)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 13.3098,
    y: 5.3501,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.0625 11.4275) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 19.2241,
    y: 0.6194,
    width: 0.878,
    height: 0.878,
    transform: "translate(5.0013 14.2033) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 18.6323,
    y: 1.2097,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.42 13.9684) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 18.0409,
    y: 1.8007,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(3.829 13.7231) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 17.4495,
    y: 2.3929,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(3.2369 13.4787) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 16.8581,
    y: 2.9839,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.646 13.2336) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 16.2673,
    y: 3.5764,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.0395 12.9654) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 15.6753,
    y: 4.1667,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.463 12.7435) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 15.0835,
    y: 4.758,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.8657 12.4864) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 14.4924,
    y: 5.3501,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.285 12.2655) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 19.2241,
    y: 1.8005,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.1756 14.5599) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 18.6321,
    y: 2.3929,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(3.5833 14.3149) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 18.0407,
    y: 2.9839,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.9922 14.0697) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 17.4499,
    y: 3.5764,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.3845 13.8003) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 16.8583,
    y: 4.1669,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(1.8096 13.5801) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 16.2671,
    y: 4.758,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.2117 13.3227) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 15.6751,
    y: 5.3499,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.6263 13.0901) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 19.2239,
    y: 2.9837,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(3.3388 14.9065) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 18.6325,
    y: 3.5764,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.7295 14.6351) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 18.0409,
    y: 4.1669,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.1558 14.4161) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 17.4497,
    y: 4.758,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.5574 14.1582) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 16.8581,
    y: 5.3501,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.9728 13.9267) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 19.2241,
    y: 4.1667,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.5024 15.2529) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 18.6323,
    y: 4.758,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.9031 14.9938) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: 18.0407,
    y: 5.3501,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.3191 14.7627) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 19.2239,
    y: 5.3499,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.6657 15.5995) rotate(-45)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: -0.8835,
    y: -0.5641,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.0419 -0.351) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 0.2995,
    y: -0.5638,
    width: 0.8776,
    height: 0.8776,
    transform: "translate(0.3056 0.4861) rotate(-45.0918)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: -0.2927,
    y: 0.0268,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.2867 0.2401) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: -0.8834,
    y: 0.6194,
    width: 0.8779,
    height: 0.8779,
    transform: "translate(-0.8782 -0.0044) rotate(-44.9815)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 1.4812,
    y: -0.5641,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(0.6514 1.3217) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-81",
    x: 0.8904,
    y: 0.0267,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.06 1.0766) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 0.2996,
    y: 0.6197,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(-0.5323 0.8332) rotate(-45.0503)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: -0.2925,
    y: 1.2098,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-1.1234 0.5869) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: -0.8833,
    y: 1.8006,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-1.7145 0.3422) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 2.6643,
    y: -0.5641,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(0.9982 2.1587) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 2.0735,
    y: 0.0267,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.4065 1.9132) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 1.4813,
    y: 0.6194,
    width: 0.8779,
    height: 0.8779,
    transform: "translate(-0.1861 1.6672) rotate(-44.9815)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 0.8906,
    y: 1.2097,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.7764 1.4231) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-86",
    x: 0.2996,
    y: 1.8009,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(-1.3691 1.1814) rotate(-45.0918)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-86",
    x: -0.2927,
    y: 2.393,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.9605 0.9339) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: -0.8835,
    y: 2.9838,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-2.5516 0.6891) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 3.8474,
    y: -0.5641,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(1.3439 2.9945) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 3.2558,
    y: 0.0271,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(0.7536 2.7501) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 2.6644,
    y: 0.6194,
    width: 0.8779,
    height: 0.8779,
    transform: "translate(0.1601 2.5035) rotate(-44.9815)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 2.0737,
    y: 1.2097,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.4299 2.2597) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 1.4814,
    y: 1.8006,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-1.0213 2.015) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 0.8904,
    y: 2.3929,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.6132 1.7697) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 0.2995,
    y: 2.9841,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-2.2071 1.5293) rotate(-45.0918)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: -0.2924,
    y: 3.5765,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(-2.793 1.276) rotate(-44.9307)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: -0.8833,
    y: 4.1668,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-3.3884 1.0359) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 5.0306,
    y: -0.5641,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(1.6904 3.8311) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-86",
    x: 4.4383,
    y: 0.0267,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.0991 3.5854) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 3.8476,
    y: 0.6194,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.5055 3.3383) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 3.256,
    y: 1.2101,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(-0.0831 3.0969) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 2.6645,
    y: 1.8006,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-0.6744 2.8519) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 2.0735,
    y: 2.3929,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.2666 2.6063) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 1.4812,
    y: 2.9838,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.8583 2.3619) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 0.8908,
    y: 3.5764,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-2.4467 2.1101) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: 0.2996,
    y: 4.1671,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(-3.0449 1.8771) rotate(-45.0918)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-95",
    x: -0.2925,
    y: 4.7581,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-3.6306 1.6242) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-96",
    x: -0.8835,
    y: 5.35,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-4.2255 1.3829) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 6.2122,
    y: -0.5641,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(2.0365 4.6666) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 5.6214,
    y: 0.0267,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.4457 4.422) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 5.0307,
    y: 0.6194,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.8514 4.1743) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 4.4385,
    y: 1.2097,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.2627 3.9318) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-97",
    x: 3.8476,
    y: 1.8005,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.3281 3.687) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-97",
    x: 3.2558,
    y: 2.3933,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.9202 3.4439) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-97",
    x: 2.6643,
    y: 2.9838,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.5115 3.1988) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 2.0739,
    y: 3.5764,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-2.1015 2.9453) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: 1.4814,
    y: 4.1668,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-2.6951 2.7087) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: 0.8906,
    y: 4.758,
    width: 0.878,
    height: 0.878,
    transform: "translate(-3.2832 2.4586) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-98",
    x: 0.2995,
    y: 5.3503,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-3.883 2.225) rotate(-45.0918)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 7.3953,
    y: -0.5641,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(2.383 5.5032) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 6.8045,
    y: 0.0267,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.7922 5.2585) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-97",
    x: 6.2124,
    y: 0.6194,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.1969 5.0093) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 5.6216,
    y: 1.2097,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.6093 4.7684) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-97",
    x: 5.0307,
    y: 1.8006,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.0184 4.5236) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-99",
    x: 4.4383,
    y: 2.3929,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.574 4.2784) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-99",
    x: 3.8474,
    y: 2.9837,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.1648 4.0336) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 3.2561,
    y: 3.5767,
    width: 0.877,
    height: 0.877,
    transform: "translate(-1.7568 3.7819) rotate(-44.9307)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-95",
    x: 2.6645,
    y: 4.1668,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-2.3482 3.5456) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 2.0737,
    y: 4.758,
    width: 0.878,
    height: 0.878,
    transform: "translate(-2.9374 3.2945) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: 1.4812,
    y: 5.35,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-3.5322 3.0556) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-97",
    x: 8.5781,
    y: -0.5641,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(2.7295 6.3395) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-99",
    points: "9.046 0.466 8.426 1.087 7.806 0.466 8.426 -0.155 9.046 0.466"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 7.3955,
    y: 0.6194,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.5428 5.8453) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 6.8047,
    y: 1.2097,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.9558 5.605) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 6.2124,
    y: 1.8005,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.3645 5.3592) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 5.6214,
    y: 2.3929,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.2275 5.115) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-99",
    x: 5.0306,
    y: 2.9837,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(-0.8183 4.8702) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 4.4387,
    y: 3.5764,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-1.4116 4.6148) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-95",
    x: 3.8476,
    y: 4.1667,
    width: 0.878,
    height: 0.878,
    transform: "translate(-2.0012 4.3801) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-95",
    x: 3.256,
    y: 4.7584,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(-2.5923 4.1321) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-103",
    x: 2.6643,
    y: 5.35,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-3.1853 3.8925) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-97",
    x: 9.7615,
    y: -0.5641,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(3.079 7.1792) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 9.1697,
    y: 0.0267,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.485 6.9311) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 8.5783,
    y: 0.6194,
    width: 0.8779,
    height: 0.8779,
    transform: "translate(1.8886 6.681) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 7.9876,
    y: 1.2101,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(1.306 6.4469) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 7.3955,
    y: 1.8005,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.7111 6.1958) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 6.8045,
    y: 2.3929,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.119 5.9516) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 6.2122,
    y: 2.9837,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.4722 5.7058) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 5.6218,
    y: 3.5764,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-1.0664 5.45) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 5.0307,
    y: 4.1668,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.6547 5.2167) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 4.4385,
    y: 4.758,
    width: 0.878,
    height: 0.878,
    transform: "translate(-2.2461 4.9654) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 3.8474,
    y: 5.3499,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-2.838 4.7267) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 10.9441,
    y: -0.564,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.4223 8.0123) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 10.3527,
    y: 0.0269,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.8373 7.7738) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 9.7616,
    y: 0.6194,
    width: 0.8779,
    height: 0.8779,
    transform: "translate(2.2372 7.5203) rotate(-44.9815)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 9.1699,
    y: 1.2097,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.6486 7.2775) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 8.5783,
    y: 1.8006,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(1.0575 7.0321) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-100",
    points: "9.046 2.832 8.426 3.453 7.806 2.832 8.426 2.211 9.046 2.832"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 7.3953,
    y: 2.9837,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.1257 6.5424) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 6.8049,
    y: 3.5764,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.7212 6.2853) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 6.2124,
    y: 4.1667,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.3086 6.0522) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 5.6216,
    y: 4.758,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.9003 5.8013) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 5.0306,
    y: 5.3499,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(-2.4915 5.5633) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 12.1263,
    y: -0.5641,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(3.7687 8.8485) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 11.5349,
    y: 0.0269,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.1783 8.604) rotate(-45.0046)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 10.9442,
    y: 0.6195,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.5803 8.3526) rotate(-44.9579)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 10.3529,
    y: 1.2099,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.0002 8.1209) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 9.7617,
    y: 1.8006,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(1.4063 7.8724) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 9.1697,
    y: 2.3929,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.8118 7.6241) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 8.5781,
    y: 2.9838,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(0.2207 7.3787) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 7.9878,
    y: 3.5767,
    width: 0.877,
    height: 0.877,
    transform: "translate(-0.3737 7.1272) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 7.3955,
    y: 4.1667,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.9621 6.8888) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 6.8047,
    y: 4.758,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.5544 6.6372) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 6.2122,
    y: 5.3499,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-2.1454 6.3988) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 13.3098,
    y: -0.564,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.1224 9.6922) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 12.7181,
    y: 0.0267,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(3.5242 9.44) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 12.1264,
    y: 0.6194,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.926 9.1881) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 11.5351,
    y: 1.2099,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.3418 8.9505) rotate(-45.0046)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 10.9442,
    y: 1.8007,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(1.7504 8.7049) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 10.3527,
    y: 2.3931,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.1628 8.4682) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 9.7615,
    y: 2.9838,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(0.5693 8.2193) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 9.1701,
    y: 3.5764,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.0311 7.9551) rotate(-44.9082)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 8.5783,
    y: 4.1668,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-0.6157 7.7251) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 7.9876,
    y: 4.7584,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(-1.2069 7.4805) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 7.3953,
    y: 5.3499,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.7988 7.2354) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 14.4925,
    y: -0.564,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.4703 10.53) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 13.9007,
    y: 0.0267,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(3.8707 10.2764) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 13.3099,
    y: 0.6195,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(3.2785 10.0318) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 12.7182,
    y: 1.2098,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.6878 9.7865) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 12.1264,
    y: 1.8006,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.0967 9.541) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 11.5349,
    y: 2.3931,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.505 9.2972) rotate(-45.0046)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 10.944,
    y: 2.9839,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.9136 9.0515) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 10.3531,
    y: 3.5765,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(0.3178 8.7985) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 9.7617,
    y: 4.1668,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-0.2675 8.5661) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 9.1699,
    y: 4.758,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.863 8.3084) rotate(-44.9544)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 8.5781,
    y: 5.35,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.4524 8.0717) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 15.6751,
    y: -0.5641,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(4.8081 11.3579) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 15.0833,
    y: 0.0267,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(4.217 11.1125) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 14.4926,
    y: 0.6195,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(3.6257 10.869) rotate(-45.0046)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 13.9009,
    y: 1.2097,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.0343 10.6229) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-97",
    x: 13.3099,
    y: 1.8007,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.4492 10.386) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-97",
    x: 12.7181,
    y: 2.3929,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(1.8511 10.1331) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 12.1263,
    y: 2.9837,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(1.26 9.8876) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-97",
    x: 11.5352,
    y: 3.5765,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(0.6593 9.6255) rotate(-44.9122)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-97",
    x: 10.9442,
    y: 4.1669,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(0.0772 9.3979) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-97",
    x: 10.3529,
    y: 4.7582,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.514 9.1531) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-99",
    x: 9.7615,
    y: 5.35,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.1046 8.913) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-95",
    x: 16.8582,
    y: -0.564,
    width: 0.878,
    height: 0.878,
    transform: "translate(5.1547 12.1945) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 16.2669,
    y: 0.0267,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(4.5637 11.9495) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 15.6753,
    y: 0.6194,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.9637 11.6957) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 15.0835,
    y: 1.2097,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.3806 11.459) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 14.4926,
    y: 1.8007,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.797 11.2239) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-97",
    x: 13.9007,
    y: 2.3929,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.1975 10.9695) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-97",
    x: 13.3098,
    y: 2.9839,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.6119 10.7332) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 12.7184,
    y: 3.5764,
    width: 0.8776,
    height: 0.8776,
    transform: "translate(1.0041 10.46) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 12.1264,
    y: 4.1668,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.4236 10.2341) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 11.5351,
    y: 4.7582,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.1713 9.9802) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-97",
    x: 10.944,
    y: 5.3501,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.7595 9.7445) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 18.0408,
    y: -0.564,
    width: 0.878,
    height: 0.878,
    transform: "translate(5.501 13.0306) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 17.4495,
    y: 0.0267,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(4.91 12.7857) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-97",
    x: 16.8583,
    y: 0.6195,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(4.3096 12.5317) rotate(-44.9591)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-97",
    x: 16.2671,
    y: 1.2097,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.7273 12.2959) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 15.6753,
    y: 1.8005,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.1362 12.0505) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 15.0833,
    y: 2.3929,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.5438 11.8056) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 14.4924,
    y: 2.9839,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.9595 11.5711) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 13.9011,
    y: 3.5764,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(1.3492 11.2951) rotate(-44.9082)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 13.3099,
    y: 4.1669,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(0.7749 11.0803) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 12.7182,
    y: 4.7581,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.1743 10.8153) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 12.1263,
    y: 5.3499,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(-0.4132 10.5807) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 19.2239,
    y: -0.5641,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(5.8476 13.8673) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-95",
    x: 18.6321,
    y: 0.0267,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(5.2564 13.6219) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-99",
    x: 18.0409,
    y: 0.6195,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(4.6553 13.3671) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-97",
    x: 17.4497,
    y: 1.2097,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.0736 13.1321) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 16.8583,
    y: 1.8007,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(3.4827 12.887) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-86",
    x: 16.2669,
    y: 2.3929,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.8905 12.6425) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 15.6751,
    y: 2.9837,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.2994 12.3971) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 15.0837,
    y: 3.5764,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(1.6942 12.1298) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 14.4926,
    y: 4.1669,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(1.1225 11.9183) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 13.9009,
    y: 4.758,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.5201 11.651) rotate(-44.9544)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 13.3098,
    y: 5.3501,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.0625 11.4275) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-97",
    x: 19.2241,
    y: 0.6194,
    width: 0.878,
    height: 0.878,
    transform: "translate(5.0013 14.2033) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-97",
    x: 18.6323,
    y: 1.2097,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.42 13.9684) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 18.0409,
    y: 1.8007,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(3.829 13.7231) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 17.4495,
    y: 2.3929,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(3.2369 13.4787) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 16.8581,
    y: 2.9839,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.646 13.2336) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 16.2673,
    y: 3.5764,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.0395 12.9654) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 15.6753,
    y: 4.1667,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.463 12.7435) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 15.0835,
    y: 4.758,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.8657 12.4864) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 14.4924,
    y: 5.3501,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.285 12.2655) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 19.2241,
    y: 1.8005,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.1756 14.5599) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 18.6321,
    y: 2.3929,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(3.5833 14.3149) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 18.0407,
    y: 2.9839,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.9922 14.0697) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 17.4499,
    y: 3.5764,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.3845 13.8003) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 16.8583,
    y: 4.1669,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(1.8096 13.5801) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-81",
    x: 16.2671,
    y: 4.758,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.2117 13.3227) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 15.6751,
    y: 5.3499,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.6263 13.0901) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 19.2239,
    y: 2.9837,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(3.3388 14.9065) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 18.6325,
    y: 3.5764,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.7295 14.6351) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-105",
    x: 18.0409,
    y: 4.1669,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.1558 14.4161) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 17.4497,
    y: 4.758,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.5574 14.1582) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-105",
    x: 16.8581,
    y: 5.3501,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.9728 13.9267) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-106",
    x: 19.2241,
    y: 4.1667,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.5024 15.2529) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-106",
    x: 18.6323,
    y: 4.758,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.9031 14.9938) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 18.0407,
    y: 5.3501,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.3191 14.7627) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 19.2239,
    y: 5.3499,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.6657 15.5995) rotate(-45)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-108"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: -0.8835,
    y: -0.5641,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.0419 -0.351) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 0.2995,
    y: -0.5638,
    width: 0.8776,
    height: 0.8776,
    transform: "translate(0.3056 0.4861) rotate(-45.0918)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: -0.2927,
    y: 0.0268,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.2867 0.2401) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-110",
    x: -0.8834,
    y: 0.6194,
    width: 0.8779,
    height: 0.8779,
    transform: "translate(-0.8782 -0.0044) rotate(-44.9815)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 1.4812,
    y: -0.5641,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(0.6514 1.3217) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 0.8904,
    y: 0.0267,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.06 1.0766) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-110",
    x: 0.2996,
    y: 0.6197,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(-0.5323 0.8332) rotate(-45.0503)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-111",
    x: -0.2925,
    y: 1.2098,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-1.1234 0.5869) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: -0.8832,
    y: 1.8011,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(-1.7147 0.3423) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 2.6643,
    y: -0.5641,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(0.9982 2.1587) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 2.0735,
    y: 0.0267,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.4065 1.9132) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-110",
    x: 1.4813,
    y: 0.6194,
    width: 0.8779,
    height: 0.8779,
    transform: "translate(-0.1861 1.6672) rotate(-44.9815)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-111",
    x: 0.8906,
    y: 1.2097,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.7764 1.4231) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "1.358 2.239 0.739 2.86 0.118 2.239 0.739 1.62 1.358 2.239"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: -0.2927,
    y: 2.393,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.9605 0.9339) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: -0.8835,
    y: 2.9838,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-2.5516 0.6891) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 3.8474,
    y: -0.5641,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(1.3439 2.9945) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 3.2558,
    y: 0.0271,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(0.7536 2.7501) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-110",
    x: 2.6644,
    y: 0.6194,
    width: 0.8779,
    height: 0.8779,
    transform: "translate(0.1601 2.5035) rotate(-44.9815)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-111",
    x: 2.0737,
    y: 1.2097,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.4299 2.2597) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 1.4815,
    y: 1.8011,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(-1.0214 2.015) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 0.8904,
    y: 2.3929,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.6132 1.7697) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 0.2995,
    y: 2.9841,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-2.2071 1.5293) rotate(-45.0918)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: -0.2925,
    y: 3.5765,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-2.7954 1.2784) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: -0.8833,
    y: 4.1668,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-3.3884 1.0359) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 5.0305,
    y: -0.5639,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(1.6948 3.8351) rotate(-45.0646)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 4.4383,
    y: 0.0267,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.0991 3.5854) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-110",
    x: 3.8476,
    y: 0.6194,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.5055 3.3383) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-111",
    x: 3.256,
    y: 1.2101,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(-0.0831 3.0969) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 2.6646,
    y: 1.8011,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(-0.6746 2.852) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 2.0735,
    y: 2.3929,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.2666 2.6063) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 1.4812,
    y: 2.9838,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.8583 2.3619) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 0.8906,
    y: 3.5764,
    width: 0.878,
    height: 0.878,
    transform: "translate(-2.4484 2.1132) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 0.2996,
    y: 4.1671,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(-3.0449 1.8771) rotate(-45.0918)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: -0.2925,
    y: 4.7581,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-3.6306 1.6242) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: -0.8835,
    y: 5.35,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-4.2255 1.3829) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 6.2122,
    y: -0.5641,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(2.0365 4.6666) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 5.6214,
    y: 0.0267,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.4457 4.422) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-110",
    x: 5.0306,
    y: 0.6196,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(0.8548 4.1793) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-111",
    x: 4.4385,
    y: 1.2097,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.2627 3.9318) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 3.8478,
    y: 1.801,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.3283 3.6871) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 3.2558,
    y: 2.3933,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.9202 3.4439) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 2.6643,
    y: 2.9838,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.5115 3.1988) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 2.0737,
    y: 3.5764,
    width: 0.878,
    height: 0.878,
    transform: "translate(-2.1025 2.9491) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 1.4814,
    y: 4.1668,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-2.6951 2.7087) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-114",
    x: 0.8906,
    y: 4.758,
    width: 0.878,
    height: 0.878,
    transform: "translate(-3.2832 2.4586) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 0.2995,
    y: 5.3503,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-3.883 2.225) rotate(-45.0918)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 7.3953,
    y: -0.5641,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(2.383 5.5032) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 6.8045,
    y: 0.0267,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.7922 5.2585) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-110",
    x: 6.2124,
    y: 0.6194,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.1969 5.0093) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 5.6216,
    y: 1.2097,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.6093 4.7684) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-118",
    x: 5.0308,
    y: 1.8012,
    width: 0.8771,
    height: 0.8771,
    transform: "translate(0.0207 4.5296) rotate(-45.0646)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-118",
    x: 4.4383,
    y: 2.3929,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.574 4.2784) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 3.8474,
    y: 2.9837,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.1648 4.0336) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 3.256,
    y: 3.5768,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(-1.7571 3.7864) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 2.6645,
    y: 4.1668,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-2.3482 3.5456) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-120",
    x: 2.0737,
    y: 4.758,
    width: 0.878,
    height: 0.878,
    transform: "translate(-2.9374 3.2945) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 1.4812,
    y: 5.35,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-3.5322 3.0556) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 8.5781,
    y: -0.5641,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(2.7295 6.3395) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 7.9872,
    y: 0.0271,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.1408 6.0971) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 7.3955,
    y: 0.6194,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.5428 5.8453) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 6.8047,
    y: 1.2097,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.9558 5.605) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-118",
    x: 6.2126,
    y: 1.801,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(0.3644 5.3593) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-118",
    x: 5.6214,
    y: 2.3929,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.2275 5.115) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 5.0305,
    y: 2.984,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-0.8168 4.8771) rotate(-45.0646)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 4.4385,
    y: 3.5764,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.4113 4.6199) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 3.8476,
    y: 4.1667,
    width: 0.878,
    height: 0.878,
    transform: "translate(-2.0012 4.3801) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-120",
    x: 3.256,
    y: 4.7584,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(-2.5923 4.1321) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 2.6643,
    y: 5.35,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-3.1853 3.8925) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 9.7615,
    y: -0.5641,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(3.079 7.1792) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 9.1697,
    y: 0.0267,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.485 6.9311) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 8.5783,
    y: 0.6194,
    width: 0.8779,
    height: 0.8779,
    transform: "translate(1.8886 6.681) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 7.9874,
    y: 1.2101,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(1.304 6.4439) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-118",
    x: 7.3957,
    y: 1.801,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(0.7109 6.1959) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-118",
    x: 6.8045,
    y: 2.3929,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.119 5.9516) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 6.2122,
    y: 2.9837,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.4722 5.7058) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 5.6216,
    y: 3.5764,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.0654 5.4558) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 5.0306,
    y: 4.167,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(-1.6541 5.2245) rotate(-45.0646)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-120",
    x: 4.4385,
    y: 4.758,
    width: 0.878,
    height: 0.878,
    transform: "translate(-2.2461 4.9654) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-123",
    x: 3.8474,
    y: 5.3499,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-2.838 4.7267) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 10.9436,
    y: -0.5641,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(3.4222 8.0122) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 10.3527,
    y: 0.0269,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.8373 7.7738) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 9.7616,
    y: 0.6194,
    width: 0.8779,
    height: 0.8779,
    transform: "translate(2.2372 7.5203) rotate(-44.9815)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 9.1699,
    y: 1.2097,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.6486 7.2775) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-118",
    x: 8.5785,
    y: 1.8011,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(1.0573 7.0322) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-118",
    x: 7.9872,
    y: 2.3933,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(0.4669 6.7908) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 7.3953,
    y: 2.9837,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.1257 6.5424) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 6.8047,
    y: 3.5764,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.7196 6.2918) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 6.2124,
    y: 4.1667,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.3086 6.0522) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-120",
    x: 5.6216,
    y: 4.758,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.9003 5.8013) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-124",
    x: 5.0305,
    y: 5.3502,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-2.4918 5.572) rotate(-45.0646)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 12.1263,
    y: -0.5641,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(3.7687 8.8485) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 11.5349,
    y: 0.0269,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.1783 8.604) rotate(-45.0046)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 10.9438,
    y: 0.6193,
    width: 0.8781,
    height: 0.8781,
    transform: "translate(2.5802 8.3524) rotate(-44.9579)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 10.3529,
    y: 1.2099,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.0002 8.1209) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-118",
    x: 9.7618,
    y: 1.8011,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(1.4062 7.8725) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-118",
    x: 9.1697,
    y: 2.3929,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.8118 7.6241) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 8.5781,
    y: 2.9838,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(0.2207 7.3787) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 7.9874,
    y: 3.5768,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(-0.3727 7.1307) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 7.3955,
    y: 4.1667,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.9621 6.8888) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-125",
    x: 6.8047,
    y: 4.758,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.5544 6.6372) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-126",
    x: 6.2122,
    y: 5.3499,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-2.1454 6.3988) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 13.3098,
    y: -0.564,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.1224 9.6922) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 12.7181,
    y: 0.0267,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(3.5242 9.44) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 12.1264,
    y: 0.6194,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.926 9.1881) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 11.5351,
    y: 1.2099,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.3418 8.9505) rotate(-45.0046)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-118",
    x: 10.944,
    y: 1.801,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(1.7501 8.7048) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-118",
    x: 10.3527,
    y: 2.3931,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.1628 8.4682) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 9.7615,
    y: 2.9838,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(0.5693 8.2193) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-127",
    x: 9.1699,
    y: 3.5764,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.0281 7.963) rotate(-44.9544)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 8.5783,
    y: 4.1668,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-0.6157 7.7251) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-128",
    x: 7.9874,
    y: 4.7584,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(-1.2079 7.4764) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-128",
    x: 7.3953,
    y: 5.3499,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.7988 7.2354) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 14.4925,
    y: -0.564,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.4703 10.53) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 13.9007,
    y: 0.0267,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(3.8707 10.2764) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 13.3099,
    y: 0.6195,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(3.2785 10.0318) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 12.7182,
    y: 1.2098,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.6878 9.7865) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-118",
    x: 12.1266,
    y: 1.801,
    width: 0.8776,
    height: 0.8776,
    transform: "translate(2.0966 9.5411) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-118",
    x: 11.5349,
    y: 2.3931,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.505 9.2972) rotate(-45.0046)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 10.9436,
    y: 2.9837,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.9135 9.0513) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-129",
    x: 10.3529,
    y: 3.5766,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(0.3215 8.807) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-127",
    x: 9.7617,
    y: 4.1668,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-0.2675 8.5661) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-127",
    x: 9.1699,
    y: 4.758,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.863 8.3084) rotate(-44.9544)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 8.5781,
    y: 5.35,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.4524 8.0717) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 15.6751,
    y: -0.5641,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(4.8081 11.3579) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 15.0833,
    y: 0.0267,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(4.217 11.1125) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 14.4926,
    y: 0.6195,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(3.6257 10.869) rotate(-45.0046)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 13.9009,
    y: 1.2097,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.0343 10.6229) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-118",
    x: 13.3101,
    y: 1.8011,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(2.449 10.3861) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-118",
    x: 12.7181,
    y: 2.3929,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(1.8511 10.1331) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-111",
    x: 12.1263,
    y: 2.9837,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(1.26 9.8876) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-111",
    x: 11.5351,
    y: 3.5766,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(0.6636 9.6347) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-131",
    x: 10.9438,
    y: 4.1667,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.0771 9.3977) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-129",
    x: 10.3529,
    y: 4.7582,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.514 9.1531) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-127",
    x: 9.7615,
    y: 5.35,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.1046 8.913) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 16.8582,
    y: -0.564,
    width: 0.878,
    height: 0.878,
    transform: "translate(5.1547 12.1945) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 16.2669,
    y: 0.0267,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(4.5637 11.9495) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 15.6753,
    y: 0.6194,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.9637 11.6957) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 15.0835,
    y: 1.2097,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.3806 11.459) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-118",
    x: 14.4928,
    y: 1.8011,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(2.7968 11.2239) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-118",
    x: 13.9007,
    y: 2.3929,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.1975 10.9695) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-132",
    x: 13.3098,
    y: 2.9839,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.6119 10.7332) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-133",
    x: 12.7182,
    y: 3.5765,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.0091 10.4699) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-111",
    x: 12.1264,
    y: 4.1668,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.4236 10.2341) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-111",
    x: 11.5351,
    y: 4.7582,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.1713 9.9802) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-131",
    x: 10.9436,
    y: 5.3499,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.7596 9.7443) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 18.0408,
    y: -0.564,
    width: 0.878,
    height: 0.878,
    transform: "translate(5.501 13.0306) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 17.4495,
    y: 0.0267,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(4.91 12.7857) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 16.8583,
    y: 0.6195,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(4.3096 12.5317) rotate(-44.9591)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 16.2671,
    y: 1.2097,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.7273 12.2959) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 15.6755,
    y: 1.801,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(3.136 12.0506) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 15.0833,
    y: 2.3929,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.5438 11.8056) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 14.4924,
    y: 2.9839,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.9595 11.5711) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-132",
    x: 13.9009,
    y: 3.5764,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.3549 11.3056) rotate(-44.9544)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-132",
    x: 13.3099,
    y: 4.1669,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(0.7749 11.0803) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-133",
    x: 12.7182,
    y: 4.7581,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.1743 10.8153) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-111",
    x: 12.1263,
    y: 5.3499,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(-0.4132 10.5807) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 19.2239,
    y: -0.5641,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(5.8476 13.8673) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 18.6321,
    y: 0.0267,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(5.2564 13.6219) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 18.0409,
    y: 0.6195,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(4.6553 13.3671) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-135",
    x: 17.4497,
    y: 1.2097,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.0736 13.1321) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 16.8585,
    y: 1.8011,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(3.4826 12.8871) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 16.2669,
    y: 2.3929,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.8905 12.6425) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 15.6751,
    y: 2.9837,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.2994 12.3971) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 15.0835,
    y: 3.5764,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.7005 12.141) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 14.4926,
    y: 4.1669,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(1.1225 11.9183) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-132",
    x: 13.9009,
    y: 4.758,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.5201 11.651) rotate(-44.9544)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 13.3098,
    y: 5.3501,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.0625 11.4275) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 19.2241,
    y: 0.6194,
    width: 0.878,
    height: 0.878,
    transform: "translate(5.0013 14.2033) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 18.6323,
    y: 1.2097,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.42 13.9684) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-135",
    x: 18.0411,
    y: 1.8011,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(3.8288 13.7232) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-135",
    x: 17.4495,
    y: 2.3929,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(3.2369 13.4787) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 16.8581,
    y: 2.9839,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.646 13.2336) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 16.2671,
    y: 3.5764,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.0465 12.9773) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 15.6753,
    y: 4.1667,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.463 12.7435) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 15.0835,
    y: 4.758,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.8657 12.4864) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 14.4924,
    y: 5.3501,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.285 12.2655) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 19.2243,
    y: 1.801,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(4.1754 14.5599) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 18.6321,
    y: 2.3929,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(3.5833 14.3149) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-135",
    x: 18.0407,
    y: 2.9839,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.9922 14.0697) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-135",
    x: 17.4497,
    y: 3.5764,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.3922 13.8128) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 16.8583,
    y: 4.1669,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(1.8096 13.5801) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 16.2671,
    y: 4.758,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.2117 13.3227) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 15.6751,
    y: 5.3499,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.6263 13.0901) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 19.2239,
    y: 2.9837,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(3.3388 14.9065) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 18.6323,
    y: 3.5764,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.7379 14.6484) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-135",
    x: 18.0409,
    y: 4.1669,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.1558 14.4161) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-135",
    x: 17.4497,
    y: 4.758,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.5574 14.1582) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 16.8581,
    y: 5.3501,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.9728 13.9267) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 19.2241,
    y: 4.1667,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.5024 15.2529) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 18.6323,
    y: 4.758,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.9031 14.9938) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-135",
    x: 18.0407,
    y: 5.3501,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.3191 14.7627) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 19.2239,
    y: 5.3499,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.6657 15.5995) rotate(-45)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: -0.8835,
    y: -0.5641,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.0419 -0.351) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 0.2995,
    y: -0.5638,
    width: 0.8776,
    height: 0.8776,
    transform: "translate(0.3056 0.4861) rotate(-45.0918)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: -0.2927,
    y: 0.0268,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.2867 0.2401) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-140",
    x: -0.8834,
    y: 0.6194,
    width: 0.8779,
    height: 0.8779,
    transform: "translate(-0.8782 -0.0044) rotate(-44.9815)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 1.4812,
    y: -0.5641,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(0.6514 1.3217) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 0.8904,
    y: 0.0267,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.06 1.0766) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-140",
    x: 0.2996,
    y: 0.6197,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(-0.5323 0.8332) rotate(-45.0503)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-141",
    x: -0.2925,
    y: 1.2098,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-1.1234 0.5869) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: -0.8832,
    y: 1.8011,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(-1.7147 0.3423) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 2.6643,
    y: -0.5641,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(0.9982 2.1587) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 2.0735,
    y: 0.0267,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.4065 1.9132) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-140",
    x: 1.4813,
    y: 0.6194,
    width: 0.8779,
    height: 0.8779,
    transform: "translate(-0.1861 1.6672) rotate(-44.9815)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-141",
    x: 0.8906,
    y: 1.2097,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.7764 1.4231) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "1.358 2.239 0.739 2.86 0.118 2.239 0.739 1.62 1.358 2.239"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: -0.2927,
    y: 2.393,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.9605 0.9339) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: -0.8835,
    y: 2.9838,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-2.5516 0.6891) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 3.8474,
    y: -0.5641,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(1.3439 2.9945) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 3.2558,
    y: 0.0271,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(0.7536 2.7501) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-140",
    x: 2.6644,
    y: 0.6194,
    width: 0.8779,
    height: 0.8779,
    transform: "translate(0.1601 2.5035) rotate(-44.9815)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-141",
    x: 2.0737,
    y: 1.2097,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.4299 2.2597) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 1.4815,
    y: 1.8011,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(-1.0214 2.015) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 0.8904,
    y: 2.3929,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.6132 1.7697) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 0.2995,
    y: 2.9841,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-2.2071 1.5293) rotate(-45.0918)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-142",
    x: -0.2925,
    y: 3.5765,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-2.7954 1.2784) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-142",
    x: -0.8833,
    y: 4.1668,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-3.3884 1.0359) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 5.0305,
    y: -0.5639,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(1.6948 3.8351) rotate(-45.0646)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 4.4383,
    y: 0.0267,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.0991 3.5854) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-140",
    x: 3.8476,
    y: 0.6194,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.5055 3.3383) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-141",
    x: 3.256,
    y: 1.2101,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(-0.0831 3.0969) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 2.6646,
    y: 1.8011,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(-0.6746 2.852) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 2.0735,
    y: 2.3929,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.2666 2.6063) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 1.4812,
    y: 2.9838,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.8583 2.3619) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-142",
    x: 0.8906,
    y: 3.5764,
    width: 0.878,
    height: 0.878,
    transform: "translate(-2.4484 2.1132) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-142",
    x: 0.2996,
    y: 4.1671,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(-3.0449 1.8771) rotate(-45.0918)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-143",
    x: -0.2925,
    y: 4.7581,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-3.6306 1.6242) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-143",
    x: -0.8835,
    y: 5.35,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-4.2255 1.3829) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 6.2122,
    y: -0.5641,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(2.0365 4.6666) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 5.6214,
    y: 0.0267,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.4457 4.422) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-140",
    x: 5.0306,
    y: 0.6196,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(0.8548 4.1793) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-141",
    x: 4.4385,
    y: 1.2097,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.2627 3.9318) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 3.8478,
    y: 1.801,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.3283 3.6871) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 3.2558,
    y: 2.3933,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.9202 3.4439) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 2.6643,
    y: 2.9838,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.5115 3.1988) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-142",
    x: 2.0737,
    y: 3.5764,
    width: 0.878,
    height: 0.878,
    transform: "translate(-2.1025 2.9491) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-142",
    x: 1.4814,
    y: 4.1668,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-2.6951 2.7087) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-144",
    x: 0.8906,
    y: 4.758,
    width: 0.878,
    height: 0.878,
    transform: "translate(-3.2832 2.4586) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 0.2995,
    y: 5.3503,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-3.883 2.225) rotate(-45.0918)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 7.3953,
    y: -0.5641,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(2.383 5.5032) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 6.8045,
    y: 0.0267,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.7922 5.2585) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-140",
    x: 6.2124,
    y: 0.6194,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.1969 5.0093) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-145",
    x: 5.6216,
    y: 1.2097,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.6093 4.7684) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-146",
    x: 5.0308,
    y: 1.8012,
    width: 0.8771,
    height: 0.8771,
    transform: "translate(0.0207 4.5296) rotate(-45.0646)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-146",
    x: 4.4383,
    y: 2.3929,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.574 4.2784) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 3.8474,
    y: 2.9837,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.1648 4.0336) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-147",
    x: 3.256,
    y: 3.5768,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(-1.7571 3.7864) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-147",
    x: 2.6645,
    y: 4.1668,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-2.3482 3.5456) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 2.0737,
    y: 4.758,
    width: 0.878,
    height: 0.878,
    transform: "translate(-2.9374 3.2945) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-148",
    x: 1.4812,
    y: 5.35,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-3.5322 3.0556) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 8.5781,
    y: -0.5641,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(2.7295 6.3395) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 7.9872,
    y: 0.0271,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.1408 6.0971) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 7.3955,
    y: 0.6194,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.5428 5.8453) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-145",
    x: 6.8047,
    y: 1.2097,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.9558 5.605) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-146",
    x: 6.2126,
    y: 1.801,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(0.3644 5.3593) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-146",
    x: 5.6214,
    y: 2.3929,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.2275 5.115) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 5.0305,
    y: 2.984,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-0.8168 4.8771) rotate(-45.0646)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-147",
    x: 4.4385,
    y: 3.5764,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.4113 4.6199) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-147",
    x: 3.8476,
    y: 4.1667,
    width: 0.878,
    height: 0.878,
    transform: "translate(-2.0012 4.3801) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 3.256,
    y: 4.7584,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(-2.5923 4.1321) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 2.6643,
    y: 5.35,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-3.1853 3.8925) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 9.7615,
    y: -0.5641,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(3.079 7.1792) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 9.1697,
    y: 0.0267,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.485 6.9311) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 8.5783,
    y: 0.6194,
    width: 0.8779,
    height: 0.8779,
    transform: "translate(1.8886 6.681) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-145",
    x: 7.9874,
    y: 1.2101,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(1.304 6.4439) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-146",
    x: 7.3957,
    y: 1.801,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(0.7109 6.1959) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-146",
    x: 6.8045,
    y: 2.3929,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.119 5.9516) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 6.2122,
    y: 2.9837,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.4722 5.7058) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-147",
    x: 5.6216,
    y: 3.5764,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.0654 5.4558) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-147",
    x: 5.0306,
    y: 4.167,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(-1.6541 5.2245) rotate(-45.0646)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 4.4385,
    y: 4.758,
    width: 0.878,
    height: 0.878,
    transform: "translate(-2.2461 4.9654) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 3.8474,
    y: 5.3499,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-2.838 4.7267) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 10.9436,
    y: -0.5641,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(3.4222 8.0122) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 10.3527,
    y: 0.0269,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.8373 7.7738) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 9.7616,
    y: 0.6194,
    width: 0.8779,
    height: 0.8779,
    transform: "translate(2.2372 7.5203) rotate(-44.9815)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-145",
    x: 9.1699,
    y: 1.2097,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.6486 7.2775) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-146",
    x: 8.5785,
    y: 1.8011,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(1.0573 7.0322) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-146",
    x: 7.9872,
    y: 2.3933,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(0.4669 6.7908) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 7.3953,
    y: 2.9837,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.1257 6.5424) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-147",
    x: 6.8047,
    y: 3.5764,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.7196 6.2918) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-147",
    x: 6.2124,
    y: 4.1667,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.3086 6.0522) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 5.6216,
    y: 4.758,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.9003 5.8013) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-149",
    x: 5.0305,
    y: 5.3502,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-2.4918 5.572) rotate(-45.0646)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 12.1263,
    y: -0.5641,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(3.7687 8.8485) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 11.5349,
    y: 0.0269,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.1783 8.604) rotate(-45.0046)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 10.9438,
    y: 0.6193,
    width: 0.8781,
    height: 0.8781,
    transform: "translate(2.5802 8.3524) rotate(-44.9579)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-145",
    x: 10.3529,
    y: 1.2099,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.0002 8.1209) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-146",
    x: 9.7618,
    y: 1.8011,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(1.4062 7.8725) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-146",
    x: 9.1697,
    y: 2.3929,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.8118 7.6241) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 8.5781,
    y: 2.9838,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(0.2207 7.3787) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-147",
    x: 7.9874,
    y: 3.5768,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(-0.3727 7.1307) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-147",
    x: 7.3955,
    y: 4.1667,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.9621 6.8888) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 6.8047,
    y: 4.758,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.5544 6.6372) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-151",
    x: 6.2122,
    y: 5.3499,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-2.1454 6.3988) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 13.3098,
    y: -0.564,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.1224 9.6922) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 12.7181,
    y: 0.0267,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(3.5242 9.44) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 12.1264,
    y: 0.6194,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.926 9.1881) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-145",
    x: 11.5351,
    y: 1.2099,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.3418 8.9505) rotate(-45.0046)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-146",
    x: 10.944,
    y: 1.801,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(1.7501 8.7048) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-146",
    x: 10.3527,
    y: 2.3931,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.1628 8.4682) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 9.7615,
    y: 2.9838,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(0.5693 8.2193) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-152",
    x: 9.1699,
    y: 3.5764,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.0281 7.963) rotate(-44.9544)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-147",
    x: 8.5783,
    y: 4.1668,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-0.6157 7.7251) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-153",
    x: 7.9874,
    y: 4.7584,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(-1.2079 7.4764) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-153",
    x: 7.3953,
    y: 5.3499,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.7988 7.2354) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 14.4925,
    y: -0.564,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.4703 10.53) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 13.9007,
    y: 0.0267,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(3.8707 10.2764) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 13.3099,
    y: 0.6195,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(3.2785 10.0318) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-145",
    x: 12.7182,
    y: 1.2098,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.6878 9.7865) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-146",
    x: 12.1266,
    y: 1.801,
    width: 0.8776,
    height: 0.8776,
    transform: "translate(2.0966 9.5411) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-146",
    x: 11.5349,
    y: 2.3931,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.505 9.2972) rotate(-45.0046)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 10.9436,
    y: 2.9837,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.9135 9.0513) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 10.3529,
    y: 3.5766,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(0.3215 8.807) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-152",
    x: 9.7617,
    y: 4.1668,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-0.2675 8.5661) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-152",
    x: 9.1699,
    y: 4.758,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.863 8.3084) rotate(-44.9544)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 8.5781,
    y: 5.35,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.4524 8.0717) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 15.6751,
    y: -0.5641,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(4.8081 11.3579) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 15.0833,
    y: 0.0267,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(4.217 11.1125) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 14.4926,
    y: 0.6195,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(3.6257 10.869) rotate(-45.0046)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-145",
    x: 13.9009,
    y: 1.2097,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.0343 10.6229) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-146",
    x: 13.3101,
    y: 1.8011,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(2.449 10.3861) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-146",
    x: 12.7181,
    y: 2.3929,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(1.8511 10.1331) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-141",
    x: 12.1263,
    y: 2.9837,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(1.26 9.8876) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-141",
    x: 11.5351,
    y: 3.5766,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(0.6636 9.6347) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 10.9438,
    y: 4.1667,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.0771 9.3977) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 10.3529,
    y: 4.7582,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.514 9.1531) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-152",
    x: 9.7615,
    y: 5.35,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.1046 8.913) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 16.8582,
    y: -0.564,
    width: 0.878,
    height: 0.878,
    transform: "translate(5.1547 12.1945) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 16.2669,
    y: 0.0267,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(4.5637 11.9495) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 15.6753,
    y: 0.6194,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.9637 11.6957) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-145",
    x: 15.0835,
    y: 1.2097,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.3806 11.459) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-146",
    x: 14.4928,
    y: 1.8011,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(2.7968 11.2239) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-146",
    x: 13.9007,
    y: 2.3929,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.1975 10.9695) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 13.3098,
    y: 2.9839,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.6119 10.7332) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 12.7182,
    y: 3.5765,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.0091 10.4699) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-141",
    x: 12.1264,
    y: 4.1668,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.4236 10.2341) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-141",
    x: 11.5351,
    y: 4.7582,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.1713 9.9802) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 10.9436,
    y: 5.3499,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.7596 9.7443) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 18.0408,
    y: -0.564,
    width: 0.878,
    height: 0.878,
    transform: "translate(5.501 13.0306) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 17.4495,
    y: 0.0267,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(4.91 12.7857) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 16.8583,
    y: 0.6195,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(4.3096 12.5317) rotate(-44.9591)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-145",
    x: 16.2671,
    y: 1.2097,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.7273 12.2959) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 15.6755,
    y: 1.801,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(3.136 12.0506) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 15.0833,
    y: 2.3929,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.5438 11.8056) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 14.4924,
    y: 2.9839,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.9595 11.5711) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 13.9009,
    y: 3.5764,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.3549 11.3056) rotate(-44.9544)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 13.3099,
    y: 4.1669,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(0.7749 11.0803) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 12.7182,
    y: 4.7581,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.1743 10.8153) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-141",
    x: 12.1263,
    y: 5.3499,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(-0.4132 10.5807) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 19.2239,
    y: -0.5641,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(5.8476 13.8673) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 18.6321,
    y: 0.0267,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(5.2564 13.6219) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 18.0409,
    y: 0.6195,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(4.6553 13.3671) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 17.4497,
    y: 1.2097,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.0736 13.1321) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 16.8585,
    y: 1.8011,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(3.4826 12.8871) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 16.2669,
    y: 2.3929,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.8905 12.6425) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 15.6751,
    y: 2.9837,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.2994 12.3971) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 15.0835,
    y: 3.5764,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.7005 12.141) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 14.4926,
    y: 4.1669,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(1.1225 11.9183) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 13.9009,
    y: 4.758,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.5201 11.651) rotate(-44.9544)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-159",
    x: 13.3098,
    y: 5.3501,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.0625 11.4275) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 19.2241,
    y: 0.6194,
    width: 0.878,
    height: 0.878,
    transform: "translate(5.0013 14.2033) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-160",
    x: 18.6323,
    y: 1.2097,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.42 13.9684) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 18.0411,
    y: 1.8011,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(3.8288 13.7232) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 17.4495,
    y: 2.3929,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(3.2369 13.4787) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 16.8581,
    y: 2.9839,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.646 13.2336) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 16.2671,
    y: 3.5764,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.0465 12.9773) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 15.6753,
    y: 4.1667,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.463 12.7435) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 15.0835,
    y: 4.758,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.8657 12.4864) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 14.4924,
    y: 5.3501,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.285 12.2655) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-161",
    x: 19.2243,
    y: 1.801,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(4.1754 14.5599) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-160",
    x: 18.6321,
    y: 2.3929,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(3.5833 14.3149) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 18.0407,
    y: 2.9839,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.9922 14.0697) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 17.4497,
    y: 3.5764,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.3922 13.8128) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 16.8583,
    y: 4.1669,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(1.8096 13.5801) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 16.2671,
    y: 4.758,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.2117 13.3227) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 15.6751,
    y: 5.3499,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.6263 13.0901) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-161",
    x: 19.2239,
    y: 2.9837,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(3.3388 14.9065) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-160",
    x: 18.6323,
    y: 3.5764,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.7379 14.6484) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 18.0409,
    y: 4.1669,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.1558 14.4161) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 17.4497,
    y: 4.758,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.5574 14.1582) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 16.8581,
    y: 5.3501,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.9728 13.9267) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-161",
    x: 19.2241,
    y: 4.1667,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.5024 15.2529) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-160",
    x: 18.6323,
    y: 4.758,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.9031 14.9938) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 18.0407,
    y: 5.3501,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.3191 14.7627) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-161",
    x: 19.2239,
    y: 5.3499,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.6657 15.5995) rotate(-45)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: -0.8835,
    y: -0.5641,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.0419 -0.351) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 0.2995,
    y: -0.5638,
    width: 0.8776,
    height: 0.8776,
    transform: "translate(0.3056 0.4861) rotate(-45.0918)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: -0.2927,
    y: 0.0268,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.2867 0.2401) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-162",
    x: -0.8834,
    y: 0.6194,
    width: 0.8779,
    height: 0.8779,
    transform: "translate(-0.8782 -0.0044) rotate(-44.9815)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1.4812,
    y: -0.5641,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(0.6514 1.3217) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 0.8904,
    y: 0.0267,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.06 1.0766) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-162",
    x: 0.2996,
    y: 0.6197,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(-0.5323 0.8332) rotate(-45.0503)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: -0.2925,
    y: 1.2098,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-1.1234 0.5869) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-163",
    x: -0.8832,
    y: 1.8011,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(-1.7147 0.3423) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 2.6643,
    y: -0.5641,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(0.9982 2.1587) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 2.0735,
    y: 0.0267,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.4065 1.9132) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-162",
    x: 1.4813,
    y: 0.6194,
    width: 0.8779,
    height: 0.8779,
    transform: "translate(-0.1861 1.6672) rotate(-44.9815)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 0.8906,
    y: 1.2097,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.7764 1.4231) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-163",
    points: "1.358 2.239 0.739 2.86 0.118 2.239 0.739 1.62 1.358 2.239"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-163",
    x: -0.2927,
    y: 2.393,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.9605 0.9339) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-164",
    x: -0.8835,
    y: 2.9838,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-2.5516 0.6891) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 3.8474,
    y: -0.5641,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(1.3439 2.9945) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 3.2558,
    y: 0.0271,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(0.7536 2.7501) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-162",
    x: 2.6644,
    y: 0.6194,
    width: 0.8779,
    height: 0.8779,
    transform: "translate(0.1601 2.5035) rotate(-44.9815)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 2.0737,
    y: 1.2097,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.4299 2.2597) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-163",
    x: 1.4815,
    y: 1.8011,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(-1.0214 2.015) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-163",
    x: 0.8904,
    y: 2.3929,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.6132 1.7697) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-164",
    x: 0.2995,
    y: 2.9841,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-2.2071 1.5293) rotate(-45.0918)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-165",
    x: -0.2925,
    y: 3.5765,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-2.7954 1.2784) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-165",
    x: -0.8833,
    y: 4.1668,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-3.3884 1.0359) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 5.0305,
    y: -0.5639,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(1.6948 3.8351) rotate(-45.0646)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 4.4383,
    y: 0.0267,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.0991 3.5854) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-162",
    x: 3.8476,
    y: 0.6194,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.5055 3.3383) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 3.256,
    y: 1.2101,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(-0.0831 3.0969) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-163",
    x: 2.6646,
    y: 1.8011,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(-0.6746 2.852) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-163",
    x: 2.0735,
    y: 2.3929,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.2666 2.6063) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-164",
    x: 1.4812,
    y: 2.9838,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.8583 2.3619) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-165",
    x: 0.8906,
    y: 3.5764,
    width: 0.878,
    height: 0.878,
    transform: "translate(-2.4484 2.1132) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-165",
    x: 0.2996,
    y: 4.1671,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(-3.0449 1.8771) rotate(-45.0918)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: -0.2925,
    y: 4.7581,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-3.6306 1.6242) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: -0.8835,
    y: 5.35,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-4.2255 1.3829) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 6.2122,
    y: -0.5641,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(2.0365 4.6666) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 5.6214,
    y: 0.0267,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.4457 4.422) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-162",
    x: 5.0306,
    y: 0.6196,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(0.8548 4.1793) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 4.4385,
    y: 1.2097,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.2627 3.9318) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-163",
    x: 3.8478,
    y: 1.801,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.3283 3.6871) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-163",
    x: 3.2558,
    y: 2.3933,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.9202 3.4439) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-164",
    x: 2.6643,
    y: 2.9838,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.5115 3.1988) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-165",
    x: 2.0737,
    y: 3.5764,
    width: 0.878,
    height: 0.878,
    transform: "translate(-2.1025 2.9491) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-165",
    x: 1.4814,
    y: 4.1668,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-2.6951 2.7087) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 0.8906,
    y: 4.758,
    width: 0.878,
    height: 0.878,
    transform: "translate(-3.2832 2.4586) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-167",
    x: 0.2995,
    y: 5.3503,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-3.883 2.225) rotate(-45.0918)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 7.3953,
    y: -0.5641,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(2.383 5.5032) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 6.8045,
    y: 0.0267,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.7922 5.2585) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-162",
    x: 6.2124,
    y: 0.6194,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.1969 5.0093) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-169",
    x: 5.6216,
    y: 1.2097,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.6093 4.7684) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 5.0308,
    y: 1.8012,
    width: 0.8771,
    height: 0.8771,
    transform: "translate(0.0207 4.5296) rotate(-45.0646)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 4.4383,
    y: 2.3929,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.574 4.2784) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 3.8474,
    y: 2.9837,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.1648 4.0336) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 3.256,
    y: 3.5768,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(-1.7571 3.7864) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 2.6645,
    y: 4.1668,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-2.3482 3.5456) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 2.0737,
    y: 4.758,
    width: 0.878,
    height: 0.878,
    transform: "translate(-2.9374 3.2945) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1.4812,
    y: 5.35,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-3.5322 3.0556) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 8.5781,
    y: -0.5641,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(2.7295 6.3395) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 7.9872,
    y: 0.0271,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.1408 6.0971) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-171",
    x: 7.3955,
    y: 0.6194,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.5428 5.8453) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-169",
    x: 6.8047,
    y: 1.2097,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.9558 5.605) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 6.2126,
    y: 1.801,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(0.3644 5.3593) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 5.6214,
    y: 2.3929,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.2275 5.115) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 5.0305,
    y: 2.984,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-0.8168 4.8771) rotate(-45.0646)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 4.4385,
    y: 3.5764,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.4113 4.6199) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 3.8476,
    y: 4.1667,
    width: 0.878,
    height: 0.878,
    transform: "translate(-2.0012 4.3801) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 3.256,
    y: 4.7584,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(-2.5923 4.1321) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 2.6643,
    y: 5.35,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-3.1853 3.8925) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 9.7615,
    y: -0.5641,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(3.079 7.1792) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 9.1697,
    y: 0.0267,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.485 6.9311) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-171",
    x: 8.5783,
    y: 0.6194,
    width: 0.8779,
    height: 0.8779,
    transform: "translate(1.8886 6.681) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-169",
    x: 7.9874,
    y: 1.2101,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(1.304 6.4439) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 7.3957,
    y: 1.801,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(0.7109 6.1959) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 6.8045,
    y: 2.3929,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.119 5.9516) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 6.2122,
    y: 2.9837,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.4722 5.7058) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 5.6216,
    y: 3.5764,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.0654 5.4558) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 5.0306,
    y: 4.167,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(-1.6541 5.2245) rotate(-45.0646)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 4.4385,
    y: 4.758,
    width: 0.878,
    height: 0.878,
    transform: "translate(-2.2461 4.9654) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 3.8474,
    y: 5.3499,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-2.838 4.7267) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 10.9436,
    y: -0.5641,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(3.4222 8.0122) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 10.3527,
    y: 0.0269,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.8373 7.7738) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-171",
    x: 9.7616,
    y: 0.6194,
    width: 0.8779,
    height: 0.8779,
    transform: "translate(2.2372 7.5203) rotate(-44.9815)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-169",
    x: 9.1699,
    y: 1.2097,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.6486 7.2775) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 8.5785,
    y: 1.8011,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(1.0573 7.0322) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 7.9872,
    y: 2.3933,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(0.4669 6.7908) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 7.3953,
    y: 2.9837,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.1257 6.5424) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 6.8047,
    y: 3.5764,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.7196 6.2918) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 6.2124,
    y: 4.1667,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.3086 6.0522) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 5.6216,
    y: 4.758,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.9003 5.8013) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 5.0305,
    y: 5.3502,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-2.4918 5.572) rotate(-45.0646)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 12.1263,
    y: -0.5641,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(3.7687 8.8485) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 11.5349,
    y: 0.0269,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.1783 8.604) rotate(-45.0046)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-171",
    x: 10.9438,
    y: 0.6193,
    width: 0.8781,
    height: 0.8781,
    transform: "translate(2.5802 8.3524) rotate(-44.9579)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-169",
    x: 10.3529,
    y: 1.2099,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.0002 8.1209) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 9.7618,
    y: 1.8011,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(1.4062 7.8725) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 9.1697,
    y: 2.3929,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.8118 7.6241) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 8.5781,
    y: 2.9838,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(0.2207 7.3787) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 7.9874,
    y: 3.5768,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(-0.3727 7.1307) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 7.3955,
    y: 4.1667,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.9621 6.8888) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 6.8047,
    y: 4.758,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.5544 6.6372) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 6.2122,
    y: 5.3499,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-2.1454 6.3988) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 13.3098,
    y: -0.564,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.1224 9.6922) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 12.7181,
    y: 0.0267,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(3.5242 9.44) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-171",
    x: 12.1264,
    y: 0.6194,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.926 9.1881) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-169",
    x: 11.5351,
    y: 1.2099,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.3418 8.9505) rotate(-45.0046)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 10.944,
    y: 1.801,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(1.7501 8.7048) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 10.3527,
    y: 2.3931,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.1628 8.4682) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 9.7615,
    y: 2.9838,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(0.5693 8.2193) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-172",
    x: 9.1699,
    y: 3.5764,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.0281 7.963) rotate(-44.9544)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 8.5783,
    y: 4.1668,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-0.6157 7.7251) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 7.9874,
    y: 4.7584,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(-1.2079 7.4764) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 7.3953,
    y: 5.3499,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.7988 7.2354) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 14.4925,
    y: -0.564,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.4703 10.53) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 13.9007,
    y: 0.0267,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(3.8707 10.2764) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-171",
    x: 13.3099,
    y: 0.6195,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(3.2785 10.0318) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-169",
    x: 12.7182,
    y: 1.2098,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.6878 9.7865) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 12.1266,
    y: 1.801,
    width: 0.8776,
    height: 0.8776,
    transform: "translate(2.0966 9.5411) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 11.5349,
    y: 2.3931,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.505 9.2972) rotate(-45.0046)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 10.9436,
    y: 2.9837,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.9135 9.0513) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-106",
    x: 10.3529,
    y: 3.5766,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(0.3215 8.807) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-172",
    x: 9.7617,
    y: 4.1668,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-0.2675 8.5661) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-172",
    x: 9.1699,
    y: 4.758,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.863 8.3084) rotate(-44.9544)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 8.5781,
    y: 5.35,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.4524 8.0717) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 15.6751,
    y: -0.5641,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(4.8081 11.3579) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 15.0833,
    y: 0.0267,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(4.217 11.1125) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-171",
    x: 14.4926,
    y: 0.6195,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(3.6257 10.869) rotate(-45.0046)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-169",
    x: 13.9009,
    y: 1.2097,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.0343 10.6229) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 13.3101,
    y: 1.8011,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(2.449 10.3861) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 12.7181,
    y: 2.3929,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(1.8511 10.1331) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 12.1263,
    y: 2.9837,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(1.26 9.8876) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 11.5351,
    y: 3.5766,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(0.6636 9.6347) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 10.9438,
    y: 4.1667,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.0771 9.3977) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-106",
    x: 10.3529,
    y: 4.7582,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.514 9.1531) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-172",
    x: 9.7615,
    y: 5.35,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.1046 8.913) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 16.8582,
    y: -0.564,
    width: 0.878,
    height: 0.878,
    transform: "translate(5.1547 12.1945) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 16.2669,
    y: 0.0267,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(4.5637 11.9495) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-171",
    x: 15.6753,
    y: 0.6194,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.9637 11.6957) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-169",
    x: 15.0835,
    y: 1.2097,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.3806 11.459) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 14.4928,
    y: 1.8011,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(2.7968 11.2239) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 13.9007,
    y: 2.3929,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.1975 10.9695) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-173",
    x: 13.3098,
    y: 2.9839,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.6119 10.7332) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-174",
    x: 12.7182,
    y: 3.5765,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.0091 10.4699) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 12.1264,
    y: 4.1668,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.4236 10.2341) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 11.5351,
    y: 4.7582,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.1713 9.9802) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 10.9436,
    y: 5.3499,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.7596 9.7443) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 18.0408,
    y: -0.564,
    width: 0.878,
    height: 0.878,
    transform: "translate(5.501 13.0306) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 17.4495,
    y: 0.0267,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(4.91 12.7857) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-171",
    x: 16.8583,
    y: 0.6195,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(4.3096 12.5317) rotate(-44.9591)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-169",
    x: 16.2671,
    y: 1.2097,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.7273 12.2959) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-175",
    x: 15.6755,
    y: 1.801,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(3.136 12.0506) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-176",
    x: 15.0833,
    y: 2.3929,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.5438 11.8056) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-177",
    x: 14.4924,
    y: 2.9839,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.9595 11.5711) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-173",
    x: 13.9009,
    y: 3.5764,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.3549 11.3056) rotate(-44.9544)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-173",
    x: 13.3099,
    y: 4.1669,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(0.7749 11.0803) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-174",
    x: 12.7182,
    y: 4.7581,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.1743 10.8153) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 12.1263,
    y: 5.3499,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(-0.4132 10.5807) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 19.2239,
    y: -0.5641,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(5.8476 13.8673) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 18.6321,
    y: 0.0267,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(5.2564 13.6219) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-171",
    x: 18.0409,
    y: 0.6195,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(4.6553 13.3671) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-178",
    x: 17.4497,
    y: 1.2097,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.0736 13.1321) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-179",
    x: 16.8585,
    y: 1.8011,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(3.4826 12.8871) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-175",
    x: 16.2669,
    y: 2.3929,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.8905 12.6425) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-175",
    x: 15.6751,
    y: 2.9837,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.2994 12.3971) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-176",
    x: 15.0835,
    y: 3.5764,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.7005 12.141) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-177",
    x: 14.4926,
    y: 4.1669,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(1.1225 11.9183) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-173",
    x: 13.9009,
    y: 4.758,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.5201 11.651) rotate(-44.9544)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-180",
    x: 13.3098,
    y: 5.3501,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.0625 11.4275) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-171",
    x: 19.2241,
    y: 0.6194,
    width: 0.878,
    height: 0.878,
    transform: "translate(5.0013 14.2033) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-181",
    x: 18.6323,
    y: 1.2097,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.42 13.9684) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-178",
    x: 18.0411,
    y: 1.8011,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(3.8288 13.7232) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-178",
    x: 17.4495,
    y: 2.3929,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(3.2369 13.4787) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-179",
    x: 16.8581,
    y: 2.9839,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.646 13.2336) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-175",
    x: 16.2671,
    y: 3.5764,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.0465 12.9773) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-175",
    x: 15.6753,
    y: 4.1667,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.463 12.7435) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-176",
    x: 15.0835,
    y: 4.758,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.8657 12.4864) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-177",
    x: 14.4924,
    y: 5.3501,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.285 12.2655) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-182",
    x: 19.2243,
    y: 1.801,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(4.1754 14.5599) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-181",
    x: 18.6321,
    y: 2.3929,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(3.5833 14.3149) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-178",
    x: 18.0407,
    y: 2.9839,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.9922 14.0697) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-178",
    x: 17.4497,
    y: 3.5764,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.3922 13.8128) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-179",
    x: 16.8583,
    y: 4.1669,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(1.8096 13.5801) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-175",
    x: 16.2671,
    y: 4.758,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.2117 13.3227) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-175",
    x: 15.6751,
    y: 5.3499,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.6263 13.0901) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-182",
    x: 19.2239,
    y: 2.9837,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(3.3388 14.9065) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-181",
    x: 18.6323,
    y: 3.5764,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.7379 14.6484) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-178",
    x: 18.0409,
    y: 4.1669,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.1558 14.4161) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-178",
    x: 17.4497,
    y: 4.758,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.5574 14.1582) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-179",
    x: 16.8581,
    y: 5.3501,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.9728 13.9267) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-182",
    x: 19.2241,
    y: 4.1667,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.5024 15.2529) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-181",
    x: 18.6323,
    y: 4.758,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.9031 14.9938) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-178",
    x: 18.0407,
    y: 5.3501,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.3191 14.7627) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-182",
    x: 19.2239,
    y: 5.3499,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.6657 15.5995) rotate(-45)"
  }))))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-183",
    x: -0.0002,
    width: 19.2178,
    height: 5.5723
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlue);
export default __webpack_public_path__ + "static/media/blue.4630662bc68ec1a180ad821562d2d87d.svg";
export { ForwardRef as ReactComponent };